import React from 'react';
import './Footer.scss';
import {ReactComponent as Logo} from '../../../Assets/Logo/logowhite.svg';

import { footerLinks, social } from './data';
import { Link } from 'react-router-dom';
import { AiOutlineMail } from 'react-icons/ai';
import SelectLanguage from '../SelectLanguage/SelectLanguage';
import {ReactComponent as App} from '../../../Assets/Icons/appstore.svg';
import {ReactComponent as Play} from '../../../Assets/Icons/googleplay.svg';

const Footer=(props)=>{
    return(
        <div className="footer">
           {/* <div className="first-part"> */}
           {/* </div> */}
           <div className="main-part">
             <div className="text">
               <button>Follow</button>
               <Logo />
               <p>Made with love from one designer & developer, to all designers.</p>
            <ul>
                {social.map((list) =>{
                          return(
                              <li>
                               
                                 {list.icon}
                                
                              </li>
                          )
                      })}
                  </ul>
             </div>
           <div className="middle">
            {footerLinks.map((l) => (
                <LinkCategory key={l.category} {...l} />
                ))}
          </div>
          </div>
          <div className="footer-lang">
              <div className="apps">
                <p>Download our apps:</p>
              <div className="play"></div>
              <div className="app"></div>

           <div>
            
           </div>
              </div>
              <div className="language-part">
              <SelectLanguage
            setLanguage={props.setLanguage}
            language={props.language}
          />
                  <div className="input-group">
                    <div className="inputs">
                        <AiOutlineMail className="icon" />
                        <input type="email" placeholder="Enter your email address" />
                    </div>
                    <button>Join</button>
                  </div>
              </div>
          </div>
          <div className="final-part">
              <p>© 2020 Hostdesign Inc. All rights reserved.</p>
              <p>Support:<span>support@hostdesign.com</span></p>
          </div>
        </div>
    )
}
const LinkCategory = (props) => {
    return (
      <div className="link-category">
        <span className="paragraph-3">{props.category}</span>
  
        <div className="links">
          {props.links.map((l) => {
            return (
              <Link key={l.to} to={l.to} className="footer-link">
                {l.link}
              </Link>
            );
          })}
        </div>
      </div>
    );
  };
export default Footer ;